import { render, staticRenderFns } from "./FacebookChangeBudgetStrategy.vue?vue&type=template&id=6e84b5fc"
import script from "./FacebookChangeBudgetStrategy.vue?vue&type=script&lang=js"
export * from "./FacebookChangeBudgetStrategy.vue?vue&type=script&lang=js"
import style0 from "./FacebookChangeBudgetStrategy.vue?vue&type=style&index=0&id=6e84b5fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports